export const loginAction = (user) => {
  return {
    type: 'LOGIN',
	user: user
  }
};

export const setProfile = (userProf) => {
  return {
    type: 'PROFILE',
	user: userProf
  }
};

export const logoutAction = () => {
  return {
    type: 'LOGOUT'
  }
};

export const refreshTokenAction = (user) => {
  return {
    type: 'REFRESH_TOKEN',
	user: user
  }
};

export const switchUser = (current_user_username, new_user) => {
  return {
    type: 'SWITCH',
	current_user_username: current_user_username,
	new_user: new_user
  }
};

//export const switchUserLogout = (username, user) => {
//  return {
//    type: 'SWITCH_LOGOUT',
//	username: username,
//	user: user
//  }
//};

export const switchUserLogout = (newUserToken) => {
  return {
    type: 'SWITCH_LOGOUT',
	newUserToken: newUserToken
  }
};